import { STORAGE_KEYS as OIDC_STORAGE_KEYS } from '@nvision/identity-core';

import { ENV_VARS } from '@/env';
import { APP_VERSION_KEY } from '@/services/version-guard';

import { authService } from '../../services/auth.service';

const KEYS_TO_SAVE = ['theme', OIDC_STORAGE_KEYS.isProviderDisabled, APP_VERSION_KEY];

export const logOut = () => {
  const isIdentity = ENV_VARS.REACT_APP_OIDC_AUTHORITY && ENV_VARS.REACT_APP_OIDC_CLIENT_ID;
  if (isIdentity) {
    authService.removeUser();
  }

  Object.keys(localStorage).forEach((key) => {
    if (!KEYS_TO_SAVE.includes(key)) {
      localStorage.removeItem(key);
    }
  });

  window.location.reload();
};

export const setUserLocalStorage = ({ token, ...rest }: { token: string }) => {
  if (token) {
    localStorage.setItem('token', token);
  }
  localStorage.setItem('userInfo', JSON.stringify(rest));
};

export const getUserLocalStorage = () => {
  const userInfo = localStorage.getItem('userInfo');

  return userInfo ? { userInfo: JSON.parse(userInfo) } : undefined;
};
